import type { GatewayRanking } from 'commonTypes/api/gatewayRanking';

/**
 * имя партнера - aff_id
 */
export const PARTNERS_IDS = {
  interRao: 3293,
  rosShtrafi: 2371,
  mvideo: 9250,
  shtrafiPdd: 3713,
  mailRu: 1255,
  leonidSvetekiy: 3282,
  yurijIsaj: 11887,
  avito: 12406,
  otp: 254,
  tbank: 1445,
  bip: 2652,
  oldWaybackPartner: 1778,
} as const;

export type TPartnersIdsValues = ValuesOf<typeof PARTNERS_IDS>;
export const PARTNERS_FF: Partial<Record<TPartnersIdsValues, GatewayRanking.RankingFeatureFlagsConfig>> = {
  [PARTNERS_IDS.avito]: {
    isUseSravniUser: true, // TODO: https://sravni-corp.atlassian.net/browse/CF-3671
    isAutosend: false,
    isTopXView: true,
    microCreditView: 'on',
    countProducts: 0,
    withoutAdditionalFilters: false,
    hideFilters: true,
  },
  [PARTNERS_IDS.bip]: {
    preSelectedPurpose: 'NewCar',
    isHideSummary: true,
  },
};

/**
 * Массив id партнеров, которые хотят использовать профиль сервис, сохраненные расчеты, передавая данные пользователя через JWE
 */
export const USING_PROFILE_SERVICE_WL_IDS_WITH_JWE = [PARTNERS_IDS.otp] as const;

/**
 * Массив id партнеров, которые хотят использовать профиль сервис, сохраненные расчеты, партнер должен быть встроен у нас на домене
 */
export const PARTNER_IDS_WITH_PREVIOUS_USER_DATA = [PARTNERS_IDS.avito] as const;
